import { useQueryWithUserId } from '@northladder/services';

import { AUTO_ASSESSMENTS_API } from '../autoAssessmentsAPIClient';

export const AUTO_ASSESSMENT_REQUEST_RETAKE_REASONS_QUERY_KEY =
  'auto-assessment-retake-reasons-key';

interface IUseAutoAssessmentsRetakeReasonsQueryOptions {
  identifier?: string;
}

/**
 * Custom query hook to fetch the auto assessment request details with respective
 * `sessionId`.
 */
export function useAutoAssessmentsRetakeReasonsQuery(
  options?: IUseAutoAssessmentsRetakeReasonsQueryOptions
) {
  const { identifier } = options || {};

  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [AUTO_ASSESSMENT_REQUEST_RETAKE_REASONS_QUERY_KEY],
      networkMode: 'always',
      retry: true,
      queryFn: () => AUTO_ASSESSMENTS_API.fetchRetakeReasons(identifier),
    });

  return {
    data,
    error,
    isPending,
    isFetching,
    isError,
    refetch,
  };
}
